// Edit lock for a draft the agent may be writing. Two signals:
//   - a chat turn is running (its tools — revise_draft, update_draft… — can
//     save a version of the open draft mid-turn);
//   - the draft itself is `building` (S-798: generate / update / long-form land
//     their content AFTER the reply, on the turn's maintenance hook).
// While either holds, the rail's draft is read-only, so a manual save can't
// race the agent's write. The chat (writer) and the rail (reader) are sibling
// subtrees under Home, hence a module store, like reviewFocus.
import { useSyncExternalStore } from "react";
import { useDraft } from "../../data/draftsQuery";

let turnRunning = false;
const subscribers = new Set<() => void>();

export function setAgentTurnRunning(next: boolean): void {
  if (turnRunning === next) return;
  turnRunning = next;
  for (const fn of subscribers) fn();
}

function subscribe(fn: () => void): () => void {
  subscribers.add(fn);
  return () => {
    subscribers.delete(fn);
  };
}

const getTurnRunning = (): boolean => turnRunning;

/** The reason editing `draftId` is paused, or null when the user may edit. */
export function useAgentDraftLock(draftId: string | undefined): string | null {
  const running = useSyncExternalStore(subscribe, getTurnRunning, getTurnRunning);
  const building = useDraft(draftId).data?.build?.status === "building";
  if (building) return "The agent is still writing this draft — editing unlocks when it lands.";
  if (running) return "The agent is working — editing unlocks when it finishes.";
  return null;
}
